import axios from 'axios';

// Set base URL for API requests based on environment
let apiUrl = '';

// Check environment and set appropriate API URL
if (import.meta.env.VITE_NODE_ENV === 'development') {
  apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
  console.log('Development mode: Using API URL:', apiUrl);
} else {
  // In production, use relative URL (empty string)
  apiUrl = '';
  console.log('Production mode: Using relative API URL');
}

axios.defaults.baseURL = apiUrl;

// Add interceptor to add auth token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Создаем событие для оповещения о проблемах с авторизацией
const authErrorEvent = new Event('authError');

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 errors (unauthorized)
    if (error.response && error.response.status === 401) {
      console.error('Authentication error: Token expired or invalid');
      
      // Clear token if it's expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Диспетчеризируем событие ошибки авторизации
      window.dispatchEvent(authErrorEvent);
      
      // Если пользователь находится в админке, перенаправляем на страницу входа
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
